import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import PercentIcon from "@mui/icons-material/Percent";
import React from "react";
import {
  InstrumentDiscount,
  IInstrument,
} from "./controller";
import DiscountTiersList from "./DiscountTiersList";

interface InstrumentDiscountDialogProps {
  open: boolean;
  instrument?: IInstrument;
  loading: boolean;
  error: boolean;
  discounts: InstrumentDiscount[];
  onClose: () => void;
}

const InstrumentDiscountDialog: React.FC<InstrumentDiscountDialogProps> = ({
  open,
  instrument,
  loading,
  error,
  discounts,
  onClose,
}) => {
  const baseUnitPriceCents = instrument?.priceInBrlCents ?? null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      variant="modal"
      fullWidth
      maxWidth="md"
      scroll="paper"
    >
      <DialogTitle variant="modal">
        <PercentIcon />
        {instrument ? `Descontos - ${instrument.title}` : "Descontos progressivos"}
      </DialogTitle>
      <DialogContent variant="modal">
        <Typography sx={{ mb: { xs: 1.5, md: 2 } }}>
          Visualize as faixas de quantidade e os percentuais aplicados para este
          instrumento.
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" textAlign="center" >
            Não foi possível carregar os descontos. Tente novamente mais tarde.
          </Typography>
        ) : discounts.length > 0 ? (
          <Box
            sx={{
              flex: 1,
              maxHeight: { xs: 260, md: 420 },
              overflowY: "auto",
              px: { xs: 0, sm: 1 },
            }}
          >
            <DiscountTiersList
              discounts={discounts}
              baseUnitPriceCents={baseUnitPriceCents}
            />
          </Box>
        ) : (
          <Typography textAlign="center" mt={4}>
            Este instrumento não possui descontos cadastrados no momento.
          </Typography>
        )}

      </DialogContent>
      <DialogActions variant="modal" sx={{ justifyContent: "end" }}>
        <Button variant="outlined" color="error" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstrumentDiscountDialog;
